import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';

import { Typography } from 'wui/Typography';
import { Box } from 'wui/Box';

import settingsParams from '../../settingsParams';
import { Navigation } from './Navigation';

import classes from './Header.scss';

export function Header() {
  const settings = useSettings();

  return (
    <Box direction="vertical" gap="SP3" className={classes.root}>
      <Box direction="vertical">
        <Typography variant="h2-28" className={classes.title}>
          {settings.get(settingsParams.titleText)}
        </Typography>
        <Typography variant="p2-16" className={classes.subtitle}>
          {settings.get(settingsParams.subtitleText)}
        </Typography>
      </Box>
      <Navigation />
    </Box>
  );
}

Header.displayName = 'Header';
